import { Helmet } from 'react-helmet-async';

const Metadata = ({
  appleAppId,
  defaultTitle,
  facebookDomainVerification,
  favicon,
  googleSiteVerification,
  language,
  metaDescription,
  metaKeywords,
  metaOgImage,
  metaOgSiteName,
  metaOgTitle,
  metaOgUrl,
  metaRobots,
  pageTitle,
}) => (
  <Helmet defaultTitle={defaultTitle}>
    <html lang={language} />
    {pageTitle && <title>{pageTitle}</title>}
    <meta httpEquiv="Content-type" content="text/html; charset=utf-8" />
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=3"
    />
    <meta name="creator" content="WayBetter" />
    {facebookDomainVerification && (
      <meta
        name="facebook-domain-verification"
        content={facebookDomainVerification}
      />
    )}
    {googleSiteVerification && (
      <meta name="google-site-verification" content={googleSiteVerification} />
    )}
    {favicon && <link rel="shortcut icon" href={favicon} />}
    {appleAppId && (
      <meta name="apple-itunes-app" content={`app-id=${appleAppId}`} />
    )}
    {metaDescription && <meta name="description" content={metaDescription} />}
    {metaKeywords && <meta name="keywords" content={metaKeywords} />}
    {metaRobots && <meta name="robots" content={metaRobots} />}
    {metaOgTitle && <meta property="og:title" content={metaOgTitle} />}
    {metaOgUrl && <meta property="og:url" content={metaOgUrl} />}
    {metaOgSiteName && (
      <meta property="og:site_name" content={metaOgSiteName} />
    )}
    {metaOgImage && <meta property="og:image" content={metaOgImage} />}
    {
      /* hub app id */
      <meta property="fb:app_id" content="248071199129823" />
    }
    {
      /* waybetter facebook page id */
      <meta property="fb:pages" content="395346777292321" />
    }
  </Helmet>
);

export default Metadata;
